import api from './index';
const endpoints = {
    login: '/login',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
};
export const login = async (body) => {
    const res = await api.post(endpoints.login, body);
    return { token: res.data.jwt, refreshToken: res.data.refreshToken };
};
export const getPasswordRecoveryLink = async (body) => {
    await api.post(endpoints.forgotPassword, body);
};
export const resetPassword = async (body) => {
    await api.post(endpoints.resetPassword, body);
};
